import React from "react";
import { BlinkBlur } from "react-loading-indicators";
import { useNavigate } from "react-router-dom";
import { HomeScreenOfferTemplate } from "./offerDetails/offerTemplates/HomeScreenOfferTemplate";

export default function NearByDealsSection({
	categorySections,
	loading,
	distanceKm,
}) {
	const navigate = useNavigate();

	if (loading) {
		return (
			<div className="px-3 mt-5 nearBuSection">
				<BlinkBlur
					color="#494949"
					size="medium"
					text="Loading offers..."
					textColor="#ffffff"
				/>
			</div>
		);
	}

	if (!categorySections?.length) {
		return (
			<div className="px-3 mt-4">
				<p>No nearby offers found increase distance</p>
			</div>
		);
	}

	const handleSeeAllClick = (category) => {
		navigate("/offer-list", {
			state: {
				category: category || "all",
				// subCategory: data.subCategory || "all",
				distanceKm: distanceKm,
			},
		});
	};

	return (
		<div className="pb-5">
			{categorySections.map((section) => (
				<div key={section.category} className="mt-4">
					<div className="px-3 d-flex justify-content-between align-items-center">
						<h5 className="text-capitalize">
							{section.category.replaceAll("_", " ")}
						</h5>
						<div
							onClick={() => handleSeeAllClick(section.category)}
						>
							See all
						</div>
					</div>

					{/* ======================================================
					   HORIZONTAL SCROLL
					====================================================== */}

					<div className="horizontal-scroll-offers">
						{section.offers.map((offer) => (
							<div
								key={offer.offerId}
								className="horizontal-offer-card"
							>
								<div>
									<HomeScreenOfferTemplate
										data={offer}
										type={offer.offerTemplate || "dark"}
										previewUrl={offer.image}
										distanceKm={distanceKm}
									/>
								</div>
							</div>
						))}

						<div key="001">
							<div className="see-more-offer-txt">
								<span
									onClick={() =>
										handleSeeAllClick(section.category)
									}
								>
									See More
								</span>
								<div className="mt-5">
									Or increase the distance to see more offer
								</div>
							</div>
							<div></div>
						</div>
					</div>
				</div>
			))}
		</div>
	);
}
